const NitroPageHeading = ({ heading1, heading2 }) => {

  let h1 = heading1 ? <h1 className="font-black text-center text-base md:text-5xl">{heading1}</h1> : '';
  let h2 = heading2 ? <h2 className="text-center text-xs md:text-xl mt-2 md:mt-4">{heading2}</h2> : '';

  return (
    <header>
      {h1}
      {h2}
    </header>
  );
}

export default NitroPageHeading;
